// Card wrapper with inline controls (no drag-and-drop)
import { Trash2, Edit3, ArrowUp, ArrowDown } from 'lucide-react';

export default function CardWrapper({ card, children, onDelete, onEdit, index, totalCards, onMoveUp, onMoveDown }) {
  console.log('[CardWrapper] Rendering card:', card?.type, 'at index:', index);
  
  return (
    <div className="group relative">
      {/* Card controls - top right inside card */}
      <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1 bg-white/90 backdrop-blur-sm rounded-lg shadow-sm border px-1 py-0.5 z-20">
        <button 
          onClick={onMoveUp} 
          disabled={index === 0}
          className={`p-1 rounded ${index === 0 ? 'text-gray-300 cursor-not-allowed' : 'hover:bg-gray-100 text-gray-600'}`}
          title="Move up"
        >
          <ArrowUp className="w-3.5 h-3.5" />
        </button>
        <button 
          onClick={onMoveDown} 
          disabled={index === totalCards - 1}
          className={`p-1 rounded ${index === totalCards - 1 ? 'text-gray-300 cursor-not-allowed' : 'hover:bg-gray-100 text-gray-600'}`}
          title="Move down"
        >
          <ArrowDown className="w-3.5 h-3.5" />
        </button>
        <div className="w-px h-4 bg-gray-200 mx-0.5"></div>
        <button onClick={onEdit} className="p-1 rounded hover:bg-gray-100 text-gray-600" title="Edit">
          <Edit3 className="w-3.5 h-3.5" />
        </button>
        <button onClick={() => onDelete(card)} className="p-1 rounded hover:bg-red-50 text-red-500" title="Delete">
          <Trash2 className="w-3.5 h-3.5" />
        </button>
      </div>
      {/* Order indicator badge */}
      <div className="absolute -top-2 -right-2 w-5 h-5 bg-gray-700 text-white rounded-full flex items-center justify-center text-xs font-medium z-10 opacity-60 group-hover:opacity-100 transition-opacity">
        {index + 1}
      </div>
      {children}
    </div>
  );
}
